const PAGE_TREATMENT_DETAIL = (() => {
  
  const setAnimateOnScroll = () => {
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;
    const distance = 60;
    const configEffects = {
      'fade-up': {
        from: { y: distance, opacity: 0 },
        onEnter: { y: 0, opacity: 1 },
        onLeave: { y: distance, opacity: 0 }
      },
      'fade-down': {
        from: { y: -distance, opacity: 0 },
        onEnter: { y: 0, opacity: 1 },
        onLeave: { y: -distance, opacity: 0 }
      },
      'fade-left': {
        from: { x: -distance, opacity: 0 },
        onEnter: { x: 0, opacity: 1 },
        onLeave: { x: -distance, opacity: 0 }
      },
      'fade-right': {
        from: { x: distance, opacity: 0 },
        onEnter: { x: 0, opacity: 1 },
        onLeave: { x: distance, opacity: 0 }
      }
    };
    Object.entries(configEffects).forEach(([value, effect]) => {
      const elements = gsap.utils.toArray(`[data-animate="${value}"]`);
      if (!elements.length) return;
      gsap.set(elements, effect.from);
      ScrollTrigger.batch(elements, {
        start: 'top bottom-=120',
        invalidateOnRefresh: true,
        onEnter: (item) => gsap.to(item, { ...effect.onEnter, duration: 1, stagger: 0.1 }),
        onEnterBack: (item) => gsap.to(item, { ...effect.onEnter, duration: 1, stagger: 0.1 }),
        onLeaveBack: (item) => gsap.to(item, { ...effect.onLeave, duration: 1, stagger: 0.1 })
      });
    });
  };

  const setTreatmentTabs = () => {
    const tabItems = document.querySelectorAll('.treatment-tab-wrapper__item');
    const tabContents = document.querySelectorAll('.treatment-tab-content');
    if (!tabItems.length || !tabContents.length) return;
    const handleActivateTab = (targetId) => {
      tabItems.forEach((item) => {
        const link = item.querySelector('a');
        const isActive = link?.getAttribute('href') === `#${targetId}`;
        item.classList.toggle('is-active', isActive);
        link?.setAttribute('aria-selected', String(isActive));
      });
      tabContents.forEach((content) => {
        content.classList.toggle('is-active', content.id === targetId);
      });
      if (typeof ScrollTrigger !== 'undefined') {
        requestAnimationFrame(() => ScrollTrigger.refresh());
      }
    };
    tabItems.forEach((item) => {
      const link = item.querySelector('a');
      if (!link) return;
      link.setAttribute('role', 'tab');
      link.addEventListener('click', (event) => {
        event.preventDefault();
        const targetId = link.getAttribute('href')?.replace('#', '');
        if (!targetId) return;
        handleActivateTab(targetId);
      });
    });
    // 초기: 첫 번째 탭 활성화
    const firstTargetId = tabItems[0]?.querySelector('a')?.getAttribute('href')?.replace('#', '');
    if (firstTargetId) handleActivateTab(firstTargetId);
  };

  const init = () => {
    setAnimateOnScroll();
    setTreatmentTabs();
  };
  return { init };
})();
document.addEventListener('DOMContentLoaded', () => PAGE_TREATMENT_DETAIL.init());
window.addEventListener('load', () => {
  if (typeof ScrollTrigger !== 'undefined') {
    requestAnimationFrame(() => ScrollTrigger.refresh());
  }
});